import { render, staticRenderFns } from "./gear.vue?vue&type=template&id=70e9bfc7&scoped=true"
import script from "./gear.vue?vue&type=script&lang=js"
export * from "./gear.vue?vue&type=script&lang=js"
import style0 from "./gear.vue?vue&type=style&index=0&id=70e9bfc7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9bfc7",
  null
  
)

export default component.exports